import styled from "styled-components";
import VendorVehiclePricingSummaryModal from "./VendorVehiclePricingSummaryModal";
import COLOURS from "../../../views/theme/base/colours.js";

const StyledVendorVehiclePricingSummaryModal = styled(VendorVehiclePricingSummaryModal)`
    .primaryText {
        display: flex;
        position: relative;
        align-items: center;
        color: ${COLOURS.PRIMARY.base}!important;
    }

    .redText {
        display: flex;
        position: relative;
        align-items: center;
        color: ${COLOURS.ALERT_RED}!important;
        margin-right: 0.4rem;
    }

    .greenText {
        display: flex;
        position: relative;
        align-items: center;
        color: ${COLOURS.ACTION_GREEN}!important;
        font-weight: bold;
    }

    .primaryText-bold {
        color: ${COLOURS.PRIMARY.base}!important;
        display: flex;
        position: relative;
        align-items: center;
        font-weight: bold;
    }
`
export default StyledVendorVehiclePricingSummaryModal;